export const securityKeys = Object.freeze({
    DASHBOARD: "Dashboard",
    SKILL_CONFIGURATION: "Skill Configuration",
    SKILL_CATEGORIES: "Skill Categories",
    ADD_SKILL_CATEGORIES: "Add Skill Categories",
    UPDATE_SKILL_CATEGORIES: "Update Skill Categories",
    DELETE_SKILL_CATEGORIES: "Delete Skill Categories",
    LIST_SKILL_CATEGORIES: "List Skill Categories",
    SKILL_MANAGEMENT: "Skill Management",
    ADD_SKILL_MANAGEMENT: "Add Skill Management",
    UPDATE_SKILL_MANAGEMENT: "Update Skill Management",
    DELETE_SKILL_MANAGEMENT: "Delete Skill Management",
    LIST_SKILL_MANAGEMENT: "List Skill Management",
    HUMAN_RESOURCE: "Human Resource",
    APPLICANT: "Applicant",
    ADD_APPLICANT: "Add Applicant",
    UPDATE_APPLICANT: "Update Applicant",
    DELETE_APPLICANT: "Delete Applicant",
    LIST_APPLICANT: "List Applicant",
    APPLICANT_INTERACTION: "Applicant Interaction",
    ADD_APPLICANT_INTERACTION: "Add Applicant Interaction",
    UPDATE_APPLICANT_INTERACTION: "Update Applicant Interaction",
    DELETE_APPLICANT_INTERACTION: "Delete Applicant Interaction",
    LIST_APPLICANT_INTERACTION: "List Applicant Interaction",
    ORGANIZATION: "Organization",
    MANAGE_ORGANIZATION: "Manage Organization",
    ADD_MANAGE_ORGANIZATION: "Add Manage Organization",
    UPDATE_MANAGE_ORGANIZATION: "Update Manage Organization",
    LIST_MANAGE_ORGANIZATION: "List Manage Organization",
    DELETE_MANAGE_ORGANIZATION: "Delete Manage Organization",
    ORGANIZATION_BRANDING: "Organization Branding",
    ORGANIZATION_EMAIL_CONFIGURATION: "Organization Email Configuration",
    SYSTEM_CONFIGURATION: "System Configuration",
    INTERVIEW_ROUND: "Interview Round",
    ADD_INTERVIEW_ROUND: "Add Interview Round",
    UPDATE_INTERVIEW_ROUND: "Update Interview Round",
    LIST_INTERVIEW_ROUND: "List Interview Round",
    DELETE_INTERVIEW_ROUND: "Delete Interview Round",
    INTERVIEW_TYPE: "Interview Type",
    ADD_INTERVIEW_TYPE: "Add Interview Type",
    UPDATE_INTERVIEW_TYPE: "Update Interview Type",
    LIST_INTERVIEW_TYPE: "List Interview Type",
    DELETE_INTERVIEW_TYPE: "Delete Interview Type",
    JOB_OPENINGS: "Job Openings",
    ADD_JOB_OPENINGS: "Add Job Openings",
    UPDATE_JOB_OPENINGS: "Update Job Openings",
    LIST_JOB_OPENINGS: "List Job Openings",
    DELETE_JOB_OPENINGS: "Delete Job Openings",
    REJECTED_REASON: "Rejected Reason",
    ADD_REJECTED_REASON: "Add Rejected Reason",
    UPDATE_REJECTED_REASON: "Update Rejected Reason",
    LIST_REJECTED_REASON: "List Rejected Reason",
    DELETE_REJECTED_REASON: "Delete Rejected Reason",
    FOLLOWUP_REASON: "Follow - up Reason",
    ADD_FOLLOWUP_REASON: "Add Follow - up Reason",
    UPDATE_FOLLOWUP_REASON: "Update Follow - up Reason",
    LIST_FOLLOWUP_REASON: "List Follow - up Reason",
    DELETE_FOLLOWUP_REASON: "Delete Follow - up Reason",
    MANAGEMENT: "Management",
    MANAGE_USERS: "Manage Users",
    ADD_USERS: "Add Users",
    UPDATE_USERS: "Update Users",
    LIST_USERS: "List Users",
    DELETE_USERS: "Delete Users",
    MANAGE_ROLES: "Manage Roles",
    ADD_ROLES: "Add Roles",
    UPDATE_ROLES: "Update Roles",
    LIST_ROLES: "List Roles",
    DELETE_ROLES: "Delete Roles",
    MANAGE_EMAIL_TEMPLATE: "Manage Email Template",
    ADD_EMAIL_TEMPLATE: "Add Email Template",
    UPDATE_EMAIL_TEMPLATE: "Update Email Template",
    LIST_EMAIL_TEMPLATE: "List Email Template",
    DELETE_EMAIL_TEMPLATE: "Delete Email Template",
    MANAGE_APPLICANT_STATUS: "Manage Applicant Status",
    ADD_APPLICANT_STATUS: "Add Applicant Status",
    UPDATE_APPLICANT_STATUS: "Update Applicant Status",
    LIST_APPLICANT_STATUS: "List Applicant Status",
    DELETE_APPLICANT_STATUS: "Delete Applicant Status",
    MANAGE_CHANNEL: "Manage Channel",
    ADD_MANAGE_CHANNEL: "Add Manage Channel",
    UPDATE_MANAGE_CHANNEL: "Update Manage Channel",
    LIST_MANAGE_CHANNEL: "List Manage Channel",
    DELETE_MANAGE_CHANNEL: "Delete Manage Channel",
    MANAGE_SOURCE: "Manage Source",
    ADD_SOURCE: "Add Source",
    UPDATE_SOURCE: "Update Source",
    LIST_SOURCE: "List Source",
    DELETE_SOURCE: "Delete Source",
    MANAGE_DEPARTMENTS: "Manage Departments",
    ADD_DEPARTMENTS: "Add Departments",
    UPDATE_DEPARTMENTS: "Update Departments",
    LIST_DEPARTMENTS: "List Departments",
    DELETE_DEPARTMENTS: "Delete Departments",
    SECURITY: "Security",
    VIEW_PERMISSIONS: "View Permissions",
    EDIT_PERMISSION: "Edit Permission",
    REPORTS: "Reports",
    JOB_REQUISITION: "Job Requisition",
    ADD_JOB_REQUISITION: "Add Job Requisition",
    UPDATE_JOB_REQUISITION: "Update Job Requisition",
    LIST_JOB_REQUISITION: "List Job Requisition",
    DELETE_JOB_REQUISITION: "Delete Job Requisition",
    EMPLOYMENT_TYPES: "Employment Types",
    ADD_EMPLOYMENT_TYPES: "Add Employment Types",
    UPDATE_EMPLOYMENT_TYPES: "Update Employment Types",
    LIST_EMPLOYMENT_TYPES: "List Employment Types",
    DELETE_EMPLOYMENT_TYPES: "Delete Employment Types",
    INTERVIEW_WORKFLOW: "Interview Workflow",
    ADD_INTERVIEW_WORKFLOW: "Add Interview Workflow",
    UPDATE_INTERVIEW_WORKFLOW: "Update Interview Workflow",
    LIST_INTERVIEW_WORKFLOW: "List Interview Workflow",
    DELETE_INTERVIEW_WORKFLOW: "Delete Interview Workflow",
    WORKFLOW_STAGES: "Workflow Stages",
    ADD_WORKFLOW_STAGES: "Add Workflow Stages",
    UPDATE_WORKFLOW_STAGES: "Update Workflow Stages",
    LIST_WORKFLOW_STAGES: "List Workflow Stages",
    DELETE_WORKFLOW_STAGES: "Delete Workflow Stages",
    STAGE_SKILL_CONFIGURATION: "Stage Skill Configuration",
    ADD_STAGE_SKILL_CONFIGURATION: "Add Stage Skill Configuration",
    UPDATE_STAGE_SKILL_CONFIGURATION: "Update Stage Skill Configuration",
    LIST_STAGE_SKILL_CONFIGURATION: "List Stage Skill Configuration",
    DELETE_STAGE_SKILL_CONFIGURATION: "Delete Stage Skill Configuration"

});

export const securityKeyIds = Object.freeze({
    DASHBOARD: 1,
    SKILL_CONFIGURATION: 2,
    SKILL_CATEGORIES: 3,
    ADD_SKILL_CATEGORIES: 4,
    UPDATE_SKILL_CATEGORIES: 5,
    DELETE_SKILL_CATEGORIES: 6,
    LIST_SKILL_CATEGORIES: 7,
    SKILL_MANAGEMENT: 8,
    ADD_SKILL_MANAGEMENT: 9,
    UPDATE_SKILL_MANAGEMENT: 10,
    DELETE_SKILL_MANAGEMENT: 11,
    LIST_SKILL_MANAGEMENT: 12,
    HUMAN_RESOURCE: 13,
    APPLICANT: 14,
    ADD_APPLICANT: 15,
    UPDATE_APPLICANT: 16,
    DELETE_APPLICANT: 17,
    LIST_APPLICANT: 18,
    APPLICANT_INTERACTION: 19,
    ADD_APPLICANT_INTERACTION: 20,
    UPDATE_APPLICANT_INTERACTION: 21,
    DELETE_APPLICANT_INTERACTION: 22,
    LIST_APPLICANT_INTERACTION: 23,
    ORGANIZATION: 24,
    MANAGE_ORGANIZATION: 25,
    ADD_MANAGE_ORGANIZATION: 26,
    UPDATE_MANAGE_ORGANIZATION: 27,
    LIST_MANAGE_ORGANIZATION: 28,
    DELETE_MANAGE_ORGANIZATION: 29,
    ORGANIZATION_BRANDING: 30,
    ORGANIZATION_EMAIL_CONFIGURATION: 31,
    SYSTEM_CONFIGURATION: 32,
    INTERVIEW_ROUND: 33,
    ADD_INTERVIEW_ROUND: 34,
    UPDATE_INTERVIEW_ROUND: 35,
    LIST_INTERVIEW_ROUND: 36,
    DELETE_INTERVIEW_ROUND: 37,
    INTERVIEW_TYPE: 38,
    ADD_INTERVIEW_TYPE: 39,
    UPDATE_INTERVIEW_TYPE: 40,
    LIST_INTERVIEW_TYPE: 41,
    DELETE_INTERVIEW_TYPE: 42,
    JOB_OPENINGS: 43,
    ADD_JOB_OPENINGS: 44,
    UPDATE_JOB_OPENINGS: 45,
    LIST_JOB_OPENINGS: 46,
    DELETE_JOB_OPENINGS: 47,
    REJECTED_REASON: 48,
    ADD_REJECTED_REASON: 49,
    UPDATE_REJECTED_REASON: 50,
    LIST_REJECTED_REASON: 51,
    DELETE_REJECTED_REASON: 52,
    FOLLOWUP_REASON: 53,
    ADD_FOLLOWUP_REASON: 54,
    UPDATE_FOLLOWUP_REASON: 55,
    LIST_FOLLOWUP_REASON: 56,
    DELETE_FOLLOWUP_REASON: 57,
    MANAGEMENT: 58,
    MANAGE_USERS: 59,
    ADD_USERS: 60,
    UPDATE_USERS: 61,
    LIST_USERS: 62,
    DELETE_USERS: 63,
    MANAGE_ROLES: 64,
    ADD_ROLES: 65,
    UPDATE_ROLES: 66,
    LIST_ROLES: 67,
    DELETE_ROLES: 68,
    MANAGE_EMAIL_TEMPLATE: 69,
    ADD_EMAIL_TEMPLATE: 70,
    UPDATE_EMAIL_TEMPLATE: 71,
    LIST_EMAIL_TEMPLATE: 72,
    DELETE_EMAIL_TEMPLATE: 73,
    MANAGE_APPLICANT_STATUS: 74,
    ADD_APPLICANT_STATUS: 75,
    UPDATE_APPLICANT_STATUS: 76,
    LIST_APPLICANT_STATUS: 77,
    DELETE_APPLICANT_STATUS: 78,
    MANAGE_CHANNEL: 79,
    ADD_MANAGE_CHANNEL: 80,
    UPDATE_MANAGE_CHANNEL: 81,
    LIST_MANAGE_CHANNEL: 82,
    DELETE_MANAGE_CHANNEL: 83,
    MANAGE_SOURCE: 84,
    ADD_SOURCE: 85,
    UPDATE_SOURCE: 86,
    LIST_SOURCE: 87,
    DELETE_SOURCE: 88,
    MANAGE_DEPARTMENTS: 89,
    ADD_DEPARTMENTS: 90,
    UPDATE_DEPARTMENTS: 91,
    LIST_DEPARTMENTS: 92,
    DELETE_DEPARTMENTS: 93,
    SECURITY: 94,
    VIEW_PERMISSIONS: 95,
    EDIT_PERMISSION: 96,
    REPORTS: 97,
    JOB_REQUISITION: 98,
    ADD_JOB_REQUISITION: 99,
    UPDATE_JOB_REQUISITION: 100,
    LIST_JOB_REQUISITION: 101,
    DELETE_JOB_REQUISITION: 102,
    EMPLOYMENT_TYPES: 103,
    ADD_EMPLOYMENT_TYPES: 104,
    UPDATE_EMPLOYMENT_TYPES: 105,
    LIST_EMPLOYMENT_TYPES: 106,
    DELETE_EMPLOYMENT_TYPES: 107,
    INTERVIEW_WORKFLOW: 108,
    ADD_INTERVIEW_WORKFLOW: 109,
    UPDATE_INTERVIEW_WORKFLOW: 110,
    LIST_INTERVIEW_WORKFLOW: 111,
    DELETE_INTERVIEW_WORKFLOW: 112,
    WORKFLOW_STAGES: 113,
    ADD_WORKFLOW_STAGES: 114,
    UPDATE_WORKFLOW_STAGES: 115,
    LIST_WORKFLOW_STAGES: 116,
    DELETE_WORKFLOW_STAGES: 117,
    MANAGE_SKILLS: 118,
    ADD_MANAGE_SKILLS: 119,
    UPDATE_MANAGE_SKILLS: 120,
    LIST_MANAGE_SKILLS: 121,
    DELETE_MANAGE_SKILLS: 122
});